module.exports = __webpack_public_path__ + "img/48cea2c4874ad07d3871ca66af5dc9e.b84b5d2f.png";